const { serialize } = require("../../utils");
export default {
  namespaced: true,
  state: {
    path: "aljabr/tests",
  },
  actions: {
    get({ dispatch, state, rootState }, options) {
      if (rootState.authenticated) {
        return dispatch(
          "FETCH",
          {
            url: `${state.path}/?${serialize(options)}`,
            method: "GET",
            data: {},
          },
          { root: true }
        );
      }
    },
    "all-tests-for-schedule"({ dispatch, state, rootState }, options) {
      if (rootState.authenticated) {
        return dispatch(
          "FETCH",
          {
            url: `${state.path}/all-tests-for-schedule?${serialize(options)}`,
            method: "GET",
            data: {},
          },
          { root: true }
        );
      }
    },
    add({ dispatch, state, rootState }, data) {
      if (rootState.authenticated) {
        return dispatch(
          "FETCH",
          {
            url: `${state.path}/add`,
            method: "POST",
            data,
          },
          { root: true }
        );
      }
    },
    save({ dispatch, state, rootState }, data) {
      if (rootState.authenticated) {
        return dispatch(
          "FETCH",
          {
            url: `${state.path}/save`,
            method: "POST",
            data,
          },
          { root: true }
        );
      }
    },
    "get-image"({ dispatch, state, rootState }, options) {
      if (rootState.authenticated) {
        return dispatch("FETCH", { url: `${state.path}/image?${serialize(options)}`, method: "GET", data: {} }, { root: true });
      }
    },
    "get-types"({ dispatch, state, rootState }, options) {
      if (rootState.authenticated) {
        return dispatch(
          "FETCH",
          {
            url: `${state.path}/types?${serialize(options)}`,
            method: "GET",
            data: {},
          },
          { root: true }
        );
      }
    },
    "add-type"({ dispatch, state, rootState }, data) {
      if (rootState.authenticated) {
        return dispatch(
          "FETCH",
          {
            url: `${state.path}/types/add`,
            method: "POST",
            data,
          },
          { root: true }
        );
      }
    },
    "update-type"({ dispatch, state, rootState }, data) {
      if (rootState.authenticated) {
        return dispatch(
          "FETCH",
          {
            url: `${state.path}/types/update`,
            method: "POST",
            data,
          },
          { root: true }
        );
      }
    },
    "get-schedules"({ dispatch, state, rootState }, options) {
      if (rootState.authenticated) {
        return dispatch("FETCH", { url: `${state.path}/schedules?${serialize(options)}`, method: "GET", data: {} }, { root: true });
      }
    },
    "add-schedule"({ dispatch, state, rootState }, data) {
      if (rootState.authenticated) {
        return dispatch("FETCH", { url: `${state.path}/schedules/add`, method: "POST", data }, { root: true });
      }
    },
    "update-schedule"({ dispatch, state, rootState }, data) {
      if (rootState.authenticated) {
        return dispatch("FETCH", { url: `${state.path}/schedules/update`, method: "POST", data }, { root: true });
      }
    },
    "delete-schedule"({ dispatch, state, rootState }, data) {
      if (rootState.authenticated) {
        return dispatch("FETCH", { url: `${state.path}/schedules/delete`, method: "POST", data }, { root: true });
      }
    },
    "get-group-students"({ dispatch, state, rootState }, options) {
      if (rootState.authenticated) {
        return dispatch("FETCH", { url: `${state.path}/group-students?${serialize(options)}`, method: "GET", data: {} }, { root: true });
      }
    },
    analytics({ dispatch, state, rootState }, data) {
      if (rootState.authenticated) {
        return dispatch("FETCH", { url: `${state.path}/analytics`, method: "POST", data }, { root: true });
      }
    },
    "results-for-pdf"({ dispatch, state, rootState }, data) {
      if (rootState.authenticated) {
        return dispatch("FETCH", { url: `${state.path}/results-for-pdf`, method: "POST", data }, { root: true });
      }
    },
  },
};
